import { Inject, Injectable } from '@angular/core'
import { AuthContextStorageService } from '../auth/auth-context-storage.service'
import { CommonService }from '../../core/services/common.service'
import cloneDeep from 'lodash/cloneDeep'
import { SelectedDepartmentService } from '../services/selected-department.service'

@Injectable({
    providedIn: 'root'
})
export class FilterCriteriaStorageService {

    constructor(@Inject(CommonService) private commonService: CommonService,
                @Inject(SelectedDepartmentService) private selectedDepartmentService: SelectedDepartmentService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                ) {
    }

    getStorageName(key: string): string {
        return this.authContextStorageService.getProjectKey() + this.getSelectedDepartmentId() + key
    }

    getStoredOrDefaultCriteria(storageCriteria, defaultCriteria): any {
        let criteria
        if (storageCriteria && this.commonService.compareKeys(storageCriteria, defaultCriteria)) {
            criteria = storageCriteria
        } else if (storageCriteria) {
            criteria = this.commonService.mergeAttributes(defaultCriteria, storageCriteria)
        } else {
            criteria = defaultCriteria
        }

        return criteria
    }

    readFilterCriteria(key): any {
        return JSON.parse(localStorage.getItem(this.getStorageName(key)))
    }

    storeFilterCriteria(key, criteria): void {
        const storeCriteria = cloneDeep(criteria)

        if (criteria.offset) {
            storeCriteria.offset = 0
        }

        localStorage.setItem(this.getStorageName(key), JSON.stringify(storeCriteria))
    }

    deleteFilterCriteria(key: string): void {
        localStorage.removeItem(this.getStorageName(key))
    }

    private getSelectedDepartmentId(): string {
        const departmentId = this.selectedDepartmentService.getSelectedDepartmentId()

        return departmentId ? '-' + departmentId : ''
    }
}
